import type { LocalizedNames } from '@/interface/IFantasySelection';
import type { ITranslation } from '@/interface/ITranslation';
import { LanguageType } from '@/interface/enum';
import { i18n } from '@/libraries/i18n';

export function getTranslated(translations: ITranslation[] | undefined | string, language?: LanguageType): string {
    try {
        if (!translations) {
            return '';
        }

        if (typeof translations === 'string') {
            return translations;
        }

        const lang = language ?? i18n.locale.value;

        const translation = translations.find(x => x.language === lang);
        if (translation) {
            return translation.value;
        }

        const englishTranslation = translations.find(x => x.language === LanguageType.EN);
        return englishTranslation?.value ?? '';
    } catch (error) {
        console.error('translations: ', translations, error);
        return '';
    }
}

export function getTranslatedName(names: LocalizedNames | string, language?: LanguageType): string {
    if (typeof names === 'string') {
        return names;
    }

    const lang = language ?? i18n.locale.value;
    return names[lang] ?? names.EN ?? '';
}
